import { useSecureGraphqlMutation } from '@psyomics/ui-common';

import {
  UpdateSurveyResponseDocument,
  UpdateSurveyResponseInput,
  UpdateSurveyResponseMutation,
} from '../generated/survey-responses';

export const useUpdateSurveyResponse = () =>
  useSecureGraphqlMutation<
    UpdateSurveyResponseMutation,
    { input: UpdateSurveyResponseInput },
    'SurveyNotFound' | 'SurveyResponseConflict'
  >(UpdateSurveyResponseDocument, ['SurveyNotFound' as const, 'SurveyResponseConflict' as const]);
